import { IRideRepository } from '@/core/domain/repositories/IRideRepository'
import { RideAggregates } from '@/core/domain/entities/Ride'
import { Result, createOk, createErr } from '@/core/shared/utils/Result'
import { UserId, DateRangeString } from '@/core/shared/types'
import { GraphQLClientInterface } from '@/infrastructure/graphql/apolloClient'
import { GET_RIDE_AGGREGATES } from '@/infrastructure/graphql/queries/rideQueries'

export class GraphQLRideRepository implements IRideRepository {
  constructor(private readonly graphqlClient: GraphQLClientInterface) {}

  async getRideAggregates(
    userId: UserId,
    dateRange?: DateRangeString
  ): Promise<Result<RideAggregates, Error>> {
    try {
      const variables: {
        userId: UserId
        dateStart?: string
        dateEnd?: string
      } = { userId, dateEnd: undefined, dateStart: undefined }

      if (dateRange) {
        variables.dateStart = dateRange.start.split('T')[0]
        variables.dateEnd = dateRange.end.split('T')[0]
      }

      const data = await this.graphqlClient.query<{
        rideAggregates: RideAggregates
      }>({
        query: GET_RIDE_AGGREGATES,
        variables,
      })

      return createOk(data.rideAggregates)
    } catch (error) {
      console.error('Failed to fetch ride aggregates:', error)
      return createErr(
        error instanceof Error ? error : new Error('Unknown error occurred')
      )
    }
  }
}
